import { BuildType } from 'src/enums/build/build-type';
import FixedImage from 'src/components/common/fixed-image';
import fixedImages from 'src/helpers/fixed-images';
import DavidLloydLogo from 'src/components/icons/david-lloyd-logo';
import React from 'react';
import mq from 'src/styling/media-queries';

type BrandLogoProps = {
  buildType: BuildType;
};

const BrandLogo = ({ buildType }: BrandLogoProps) => {
  if (buildType === BuildType.MERIDIAN) {
    return (
      <div
        css={{
          height: '3.25rem',
          img: { objectFit: 'contain' },
        }}
      >
        <div
          css={mq({
            height: '3.25rem',
            position: [null, 'absolute'],
            width: ['fit-content', 'max-content'],
          })}
        >
          <FixedImage imageDetails={fixedImages.lightBgBlackMeridianLogo} />
        </div>
      </div>
    );
  }

  if (buildType === BuildType.HARBOUR) {
    return (
      <div css={{ height: '5rem', width: 'fit-content' }}>
        <FixedImage imageDetails={fixedImages.whiteHarbourLogo} />
      </div>
    );
  }

  return <DavidLloydLogo size="11.25rem" />;
};

export { BrandLogo };
